import ArchiveIcon from '@mui/icons-material/Archive';
import EditIcon from '@mui/icons-material/Edit';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import { TabelaBase } from '../../../../../components/formControls/TabelaBase';
import { AcessoInformacaoList } from '../types/AcessoInformacao';

interface Props {
  acessoInformacaos: AcessoInformacaoList[];
  handleExcluirtClick: (rowData: AcessoInformacaoList) => void;
  // Se quiser, também um handleEditClick ou baseEditUrl para link
  baseEditUrl?: string;
}

export const AcessoInformacaoDataTable = ({ acessoInformacaos, handleExcluirtClick, baseEditUrl }: Props) => {
  // Renderizadores podem ficar dentro do componente

  const renderCategoria = (rowData: AcessoInformacaoList) => {
    //const dataCriacao = rowData.dataHoraCriacao ? format(rowData.dataHoraCriacao, 'dd/MM/yyyy') : 'Data não disponível';
    return (
      <Typography color="secondary" variant="body2">
        {rowData.categoria !== null ? rowData.categoria : 'N/A'}
      </Typography>
    );
  };

  const renderNome = (rowData: AcessoInformacaoList) => (
    <Typography color="secondary" variant="body2">
      {rowData.nome || 'Nome não disponível ou anônimo'}
    </Typography>
  );

  const renderTelefone = (rowData: AcessoInformacaoList) => (
    <Typography color="secondary" variant="body2">
      {rowData.telefone || ''}
    </Typography>
  );

  const renderData = (rowData: AcessoInformacaoList) => {
    const dataCriacao = rowData.dataHoraCriacao ? format(rowData.dataHoraCriacao, 'dd/MM/yyyy') : 'Data não disponível';
    return (
      <Typography color="secondary" variant="body2">
        {dataCriacao}
      </Typography>
    );
  };

  const renderStatus = (rowData: AcessoInformacaoList) => {
    return !rowData.arquivado ? (
      <Tooltip title="Item arquivado">
        <ArchiveIcon sx={{ color: 'orange' }} />
      </Tooltip>
    ) : null;
  };

  const renderAction = (rowData: AcessoInformacaoList) => (
    <Box display="flex" gap={1}>
      <Tooltip title="Editar">
        {baseEditUrl ? (
          <Link to={`${baseEditUrl}${rowData.id}`}>
            <IconButton color="secondary" aria-label="edit">
              <EditIcon />
            </IconButton>
          </Link>
        ) : (
          <IconButton color="secondary" aria-label="edit">
            {/* Se quiser, pode passar um handleEditClick aqui */}
            <EditIcon />
          </IconButton>
        )}
      </Tooltip>
      {/* Botão ou ícone de Arquivar */}
      {rowData.arquivado ? (
        <Tooltip title="Desarquivar">
          <IconButton color="secondary" aria-label="desarquivar" onClick={() => handleExcluirtClick(rowData)} size="small">
            <ArchiveIcon sx={{ color: 'orange' }} />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Arquivar">
          <IconButton color="secondary" aria-label="arquivar" onClick={() => handleExcluirtClick(rowData)} size="small">
            <ArchiveIcon />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );

  const columns = [
    { header: 'Data', body: renderData, sortable: true, filter: false, filterPlaceholder: 'Filtrar por data', style: { width: 'auto' }, frozen: false },
    { header: 'Categoria', body: renderCategoria, sortable: true, filter: false, filterPlaceholder: 'Filtrar por categoria', style: { width: '15%' } },
    { header: 'Nome', body: renderNome, sortable: true, filter: false, filterPlaceholder: 'Filtrar por nome', style: { width: '40%' } },
    { header: 'Telefone', body: renderTelefone, sortable: true, filter: false, filterPlaceholder: 'Filtrar por telefone', style: { width: 'auto' } },

    { header: 'Ações', body: renderAction, style: { width: 'auto' } }
  ];

  const headerGerados = (
    <Typography variant="body2" color="textSecondary">
      Registro(s) encontrado(s): {acessoInformacaos.length}
    </Typography>
  );

  return (
    <>
      <TabelaBase
        value={acessoInformacaos}
        columns={columns}
        dataKey="id"
        header={headerGerados}
        rows={25}
        paginator
        exportCSV={false}
        scrollable
        scrollHeight="500px"
        frozenWidth="150px"
        themeClassName="meu-tema-customizado"
      />
    </>
  );
};
